<template>
    <div id="stock-setting">

    <div class="sticky-table-header">
        <vx-card style="overflow-x: auto;">
            <vs-row>
                <vs-col class="search-bar" vs-type="flex" vs-justify="right" vs-align="center">
            <vs-input icon-no-border icon="icon-search" icon-pack="feather" class="w-full input-rounded-full" placeholder="Cari BPH Setting" v-model="searchText"/>
            <vs-spacer></vs-spacer>
            <vs-tooltip text="Tambah">
              <vs-button radius size="large" type="border" color="#5d9fc6" icon="person_add" class="ml-3" @click="create()"></vs-button>
            </vs-tooltip>
			<!--vs-tooltip text="Lihat" v-if="btnView === true">
				<vs-button radius size="large" type="border" color="#5d9fc6" icon="print" class="ml-3"  @click="$router.push({name: 'purchase-view', params: {id: data.id, type:'view' }})"></vs-button>
			</vs-tooltip>
			<vs-tooltip text="Proses" v-if="btnProcess === true">
				<vs-button radius size="large" type="border" color="primary" icon="send" class="ml-3" @click="openConfirm()"></vs-button>
			</vs-tooltip>
			<vs-tooltip text="Diterima" v-if="btnReceive === true">
				<vs-button radius size="large" type="border" color="warning" icon="call_received" class="ml-3" @click="openReceive()"></vs-button>
			</vs-tooltip>
			<vs-tooltip text="Hapus" v-if="btnDel === true">
				<vs-button radius size="large" type="border" color="danger" icon="delete" class="ml-3" @click="openDelete()"></vs-button>
			</vs-tooltip-->
          </vs-col>
        </vs-row>
      </vx-card>
    </div>

      <vx-card title="Daftar BPH Setting" class="sticky-table-content mt-sticky">
        <vs-table stripe maxItemsx="10" class="mb-base" :data="listData" style="text-align:center;" @selected="handleSelected">
            <template slot="thead">
                <vs-th>Nama</vs-th>
		            <vs-th>Bagian Lab</vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody :key="indextr" v-for="(tr, indextr) in data">
                <vs-tr :data="tr" :style="tr.id==idSelected?'background: rgba(var(--vs-primary),.1)!important;':(indextr%2==0?'background: transparent!important;':'')">
                    <vs-td>
                        {{data[indextr].name}}
                    </vs-td>
                    <vs-td>
                        {{data[indextr].labSection.name}}
                    </vs-td>
                </vs-tr>
              </tbody>
            </template>
        </vs-table>
        <vs-pagination class="pagination pagination-warning" :total="totalItem" v-model="page" @input="find"></vs-pagination>
      </vx-card>
    </div>
</template>

<script>
import ref from "@/api/ref.js";
import formsearch from "@/api/form-search.js";
import stock from "@/api/stock.js";
import tool from "@/tool/form_tool.js";
import { VueContext } from "vue-context";


export default {
	components: {
		VueContext
	},
	data() {
		return {
			idSelected: null,
			listData: {maxPage:0, data: []},
			loading: true,
			perPage: 50,
			page: 1,
			totalItem: 1,

			model: {},
			schema: {
				fields: []
			},
			formOptions: {
				validateAfterLoad: true,
				validateAfterChanged: true,
				validateAsync: true
			},
            searchText: ''
		};
	},
	methods: {
		listen(newVal, schema) {
		},
		async find(pg) {
			this.model["perPage"] = this.perPage;
			this.model["page"] = pg;
			const frm = await stock.listUsage(this.model);
			if (frm.data.status != false) {
				this.listData = frm.data.data;
				this.totalItem = frm.data.maxPage;
			} else {
			   this.listData= {maxPage:0, data: []};
      }
		},
    handleSelected(tr) {
      this.idSelected = tr.id;
      /*this.btnEdit =false;
      this.btnDel = false;
      this.btnBarcode=false;
      this.btnStart=false;
      this.btnEntry=false;
      this.btnVerify=false;
      this.btnVerifyFin=false;
      this.btnDetail=false;
      this.btnPdf=false;
      this.btnLog=false;
      this.getDetail(tr.id);
      this.listWorklist.forEach(element => {
        if (element.id == this.idSelected) {
          this.btnEdit = true;
          this.btnDel = true;
          this.btnBarcode = true;
          this.btnDetail = true;
          if (element.testStatusName == 'PENDING') {
            this.btnStart = true;
          } else if (element.testStatusName == 'VERIFIED FINAL') {
            this.btnPdf = true;
            this.btnEdit = false;
            this.btnDel = false;
          } else if (element.testStatusName == 'VERIFIED') {
            this.btnEdit = true;
            this.btnVerifyFin = true;
          } else if (element.testStatusName == 'COMPLETED') {
            this.btnEdit = true;
            this.btnVerify = true;
          } else if (element.testStatusName == 'STARTED') {
            this.btnEntry=true;
            this.btnVerify=true;
            this.btnVerifyFin=true;
            this.btnPdf=true;
          }
        }
      });*/
    },
    create() {
      this.$router.push({name: 'stock-usage-entry'});
    }
	},
	computed: {},
	created() {
		//this.firstLoad();
	},
	watch: {
		page: function(newValue, oldValue) {
			// here you can do whatever you want
			this.find(newValue);
		}
	}
};
</script>
